import { omProjectConstants } from "../constant/omProject.constants";

export const initialState = {
    omProject: {
        id: '',
        omProjectCode: '',
        omProjectName: ''
    },
    dataOmProject: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const omProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case omProjectConstants.GET_SUCCESS:
            return {
                ...state,
                dataOmProject: action.omProjectList,
                isLoading: false
            };
        case omProjectConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };
        case omProjectConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        case omProjectConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case omProjectConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        case omProjectConstants.UPDATE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case omProjectConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        default:
            return state;
    }
};

export default omProjectReducer;
